import { render, staticRenderFns } from "./ProlongationChoice.vue?vue&type=template&id=0b67f657&scoped=true&"
import script from "./ProlongationChoice.vue?vue&type=script&lang=js&"
export * from "./ProlongationChoice.vue?vue&type=script&lang=js&"
import style0 from "./ProlongationChoice.vue?vue&type=style&index=0&id=0b67f657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67f657",
  null
  
)

export default component.exports